import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQueryField]" })
export class QueryFieldDirective {
  constructor(public template: TemplateRef<any>) {}
}
